module.exports = __webpack_public_path__ + "static/media/logo2.c495169e.png";